// @ts-nocheck

import { Dispatch, SetStateAction } from 'react';

import { Target } from '../../../client';
import type { CustomRouterHistory } from '../../../createHistory';
import { showWebsiteLoginForm } from '../../../utils/index';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';

export const openGRView = (
  history: CustomRouterHistory,
  delayedOptions:
    | {
        isUserConnected: boolean;
        setOnLoginSucceed: Dispatch<SetStateAction<() => void>>;
        userIsConnectedTimeoutRef: { current: TimeoutID | null };
      }
    | undefined,
) => {
  const userIsConnectedCallback = () => {
    history.push(RoutesRedirectionFactory.getGRRouteConfig());
  };

  if (delayedOptions) {
    const { isUserConnected, setOnLoginSucceed, userIsConnectedTimeoutRef } = delayedOptions;

    if (!isUserConnected) {
      if (Target.__MOBILE__) {
        setOnLoginSucceed(() => () => {
          userIsConnectedTimeoutRef.current = setTimeout(() => {
            userIsConnectedCallback();
          }, 500);
        });

        history.push(
          RoutesRedirectionFactory.getLoginRouteConfig({
            state: { modal: true },
          }),
        );
      } else {
        showWebsiteLoginForm();
      }
    } else {
      userIsConnectedCallback();
    }
  } else {
    userIsConnectedCallback();
  }
};
